import customConfirmationRuthTriviaCards from "../../../../src/content/ruth-graham-trivia-cards/customConfirmation";
import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import "../../../../src/content/ruth-graham-trivia-cards/ruth-cards.scss";
import * as React from 'react';
export default {
  customConfirmationRuthTriviaCards,
  SingleDonationForm,
  React
};